import React, { useState } from 'react';

// Component to handle image loading errors
const GameImage = ({ src, fallbackSrc, alt, ...props }) => {
  const [error, setError] = useState(false);
  
  // If primary image fails, use fallback
  const handleError = () => {
    if (!error) {
      setError(true);
    }
  };

  return (
    <img 
      src={error ? fallbackSrc : src} 
      alt={alt} 
      onError={handleError}
      {...props}
    />
  );
};

export default GameImage;
